import { render, staticRenderFns } from "./serviceCenter.vue?vue&type=template&id=71c354ec&scoped=true"
import script from "./serviceCenter.vue?vue&type=script&lang=js"
export * from "./serviceCenter.vue?vue&type=script&lang=js"
import style0 from "./serviceCenter.vue?vue&type=style&index=0&id=71c354ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c354ec",
  null
  
)

export default component.exports